<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Attendance Machine Setup</h4>
  </div>

  <div class="card-body mt-2">
    <form @submit.prevent="storeContact(attendanceMachineSetup)">
      <div class="row">
        <div class="col-sm-6 offset-md-3 col-12">
          <div class="row"  v-for="(data, index) in attendanceMachineSetup">
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Machine User ID</label>
                <input v-model="data.attendance_machine_user_id" type="number" class="form-control" id="activity"
                       placeholder="Enter Attendance Machine User Id"/>
              </div>
            </div>

            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import {defineProps, ref, watch} from "vue";
import {useRoute} from "vue-router";

const emit = defineEmits(['storeContact'])
const props = defineProps({
  items: {
    type: Array
  }
})

const route = useRoute()

const attendanceMachineSetup  = ref([
    {
      attendance_machine_user_id: '',
    }
])

const storeContact = (data) => {
  let items = data.map(item => ({
    attendance_machine_user_id: item.attendance_machine_user_id,
  }));
  emit('storeContact', {'items':items})
}

const reset = () => {
  attendanceMachineSetup.value.length = 0;
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});

const formDataSet = () => {
    if (props.items.length){
      attendanceMachineSetup.value = props.items.map(item => {
        return {
          ...item,
          attendance_machine_user_id: item.attendance_machine_user_id || null
        };
      });
    }
}

</script>
